import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pillar-xhm",
  "use": "icon-soc-pillar-xhm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-pillar-xhm\">\r\n  <!-- ② 设备·XHM：机身轮廓 + 链路节点 -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <rect x=\"192\" y=\"256\" width=\"448\" height=\"512\" rx=\"48\" />\r\n    <path d=\"M288 384h256M288 512h192M288 640h224\" />\r\n    <circle cx=\"768\" cy=\"384\" r=\"48\" />\r\n    <circle cx=\"768\" cy=\"640\" r=\"48\" />\r\n    <path d=\"M640 384h80M640 640h80M768 432v160\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pillar-xhm.svg
// module id = cCtC
// module chunks = 534